import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { Project } from '../models/project.model';
import { InvoiceType } from '../models/allocation.model';
import { environment } from '../../environments/environment';

export interface CreateProjectDto {
  name: string;
  projectCode?: string; // Project code (e.g., BID-03610)
  managerId: string;
  invoiceType: InvoiceType;
  clientId?: string;
  accountManagerId?: string;
  serviceGroupId?: string;
  costCenterId?: string;
  description?: string;
  startDate: string;
  endDate?: string;
  isActive: boolean;
  isAvailableToAllEmployees?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private apiUrl = `${environment.apiUrl}/Project`;

  constructor(private http: HttpClient) { }

  /**
   * All projects. Pass includePresales: true to also receive in-pursuit presales twins
   * (allocation grids only) — the API excludes them by default so reports, exports and
   * admin screens keep their existing result set.
   */
  getAllProjects(includePresales = false): Observable<Project[]> {
    const url = includePresales ? `${this.apiUrl}?includePresales=true` : this.apiUrl;
    return this.http.get<Project[]>(url).pipe(retry(2));
  }

  getProjectById(id: string): Observable<Project> {
    return this.http.get<Project>(`${this.apiUrl}/${id}`).pipe(retry(2));
  }

  addProject(project: Project): Observable<Project> {
    const createDto: CreateProjectDto = {
      name: project.name,
      projectCode: project.projectCode,
      managerId: project.managerId,
      invoiceType: project.invoiceType || InvoiceType.NotAvailable,
      clientId: project.clientId,
      accountManagerId: project.accountManagerId,
      serviceGroupId: project.serviceGroupId,
      costCenterId: project.costCenterId,
      description: project.description,
      startDate: project.startDate,
      endDate: project.endDate,
      isActive: project.isActive,
      isAvailableToAllEmployees: project.isAvailableToAllEmployees ?? false
    };
    return this.http.post<Project>(this.apiUrl, createDto);
  }

  updateProject(id: string, project: Project): Observable<Project> {
    return this.http.put<Project>(`${this.apiUrl}/${id}`, project);
  }
}


